import React from 'react';
import "./About.scss";
import aboutImg from "../../img/aboutImg.png";

function About(props) {
	return (
		<div className="about">
			<div className="container">
				<div className="about-content">
					<div className="about-image">
						<img src={aboutImg} alt="img" />
					</div>
					<div className="about-text">
						<h2>Кто мы?</h2>
						<p>
                            Добро пожаловать в «ДИТ» — IT-компанию, которая создает сервисы, упрощающие повседневные и бизнес-задачи. Мы специализируемся не просто на технологиях, а на практичных решениях, которые помогают быстрее работать, легче взаимодействовать с клиентами и увереннее вести международную деятельность.
                            Одно из наших ключевых направлений — финтех-решения для трансграничных расчетов и оплат. Мы помогаем сделать международные платежные процессы более понятными, удобными и доступными для всех.
                            Также мы развиваем решения в сфере туризма, которые делают получение виз в разные страны более простым, прозрачным и комфортным. Наша задача — убрать лишнюю сложность из процессов, с которыми люди и компании сталкиваются регулярно.
                            Отдельное направление нашей работы — Telegram-ассистенты для бизнеса. Мы создаем инструменты, которые автоматизируют коммуникацию с клиентами, упрощают внутренние процессы и помогают компаниям экономить время на рутинных задачах.</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default About;